module.exports = __webpack_public_path__ + "static/monei_pay_starbucks_1_es-ebd641abbef023c088d56ccb39486996.png";